import styled, { css } from 'styled-components';
import { modernViewportUnit, pxToRem } from '../../../design-tokens/style-utilities';
export const getHeight = ({ theme, $showFullHeight, }) => {
    const height = `calc(${modernViewportUnit(100, 'dvh')} - ${pxToRem(theme.spacing['900'])});`;
    return $showFullHeight ? `height: ${height}` : `max-height: ${height}`;
};
const bottomSheetBodyContainerStyles = ({ theme, $showFullHeight, }) => css `
	padding: ${pxToRem(theme.spacing['400'])};
	overflow-y: scroll;
	overscroll-behavior: contain;
	background-color: ${theme.colors.blanc.bgModal};

	${getHeight({ theme, $showFullHeight })}
`;
export const BottomSheetBodyContainer = styled.div `
	${bottomSheetBodyContainerStyles}
`;
